import styled from "styled-components";

export const MeetOurTeamCompWrapper = styled.div`
  .meet_our_teams_heading {
    max-width: 820px;
    margin: 0 auto 35px;
    P {
      font-weight: 500;
    }
  }
  .teamsCardRow {
    margin: -10px;
    @media (max-width: 1199px) {
      margin: -7px;
    }
    .teamsCard_col {
      width: 25%;
      padding: 10px;
      @media (max-width: 1199px) {
        padding: 7px;
      }
      @media (max-width: 899px) {
        display: none;
      }
    }
  }

  .slider_teams_card {
    display: none;
    .slick-list {
      margin: 0 -5px;
      .teamsCard_col {
        padding: 0 5px;
      }
    }
    @media (max-width: 899px) {
      display: block;
    }
  }
`;

export const TeamsCardSecWrapper = styled.div`
  position: relative;
  border-radius: 25px;
  overflow: hidden;
  @media (max-width: 1199px) {
    border-radius: 20px;
  }
  @media (max-width: 899px) {
    border-radius: 15px;
  }
  @media (max-width: 390px) {
    border-radius: 10px;
  }
  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 80%;
    bottom: 0;
    left: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  }
  figure {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .team_member_details_box {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    padding: 35px;
    @media (max-width: 1199px) {
      padding: 20px;
    }
    @media (max-width: 390px) {
      padding: 15px;
    }
    h3 {
      font-weight: 600;
      color: rgb(255, 24, 24);
      @media (max-width: 599px) {
        font-size: 18px;
      }
    }
    p {
      font-size: 20px;
      color: rgb(255, 255, 255);
      @media (max-width: 899px) {
        font-size: 16px;
      }
      @media (max-width: 599px) {
        font-size: 14px;
      }
    }
  }
`;
